<template>
  <div style="height: 100%;
    text-align: left;">
    <el-row>
      <el-col :span="14">
        <h3 style=" display: flex;align-items: center;height: 100%;"><img src="../assets/imgs/logo.png" />云天弈智能财经研究分析报告平台</h3>
      </el-col>
      <el-col :span="10"
              style="text-align:right;padding-top: 12px;">
        <template v-if="userInfo && userInfo.schoolType">
          <el-link :underline=false
                   target="_blank"
                   @click="payDialogVisible=true">
            <div style="float:left;padding-left:20px;text-align:center;font-szie:12px;color:white">
              <img src="../assets/imgs/price.png"
                   width="15px" /><br>
              会员套餐
            </div>
          </el-link>&nbsp;&nbsp;&nbsp;&nbsp;
        </template>
        <!--   <el-link :underline=false
                 target="_blank"
                 @click="openCustService">
          <div style="float:left;padding-left:20px;text-align:center;font-szie:12px;color:white">
            <img src="../assets/imgs/customer.png"
                 width="15px" /><br>
            在线客服
          </div>
        </el-link>&nbsp;&nbsp;&nbsp;&nbsp; -->
        <el-link :underline=false
                 target="_blank"
                 href=./static/pdf/help.pdf>
          <div style="float:left;padding-left:20px;text-align:center;font-szie:12px;color:white">
            <img src="../assets/imgs/help.png"
                 width="15px" /><br>
            帮助文档
          </div>
        </el-link>

        <!-- <el-avatar :size="25"
                   src="http://113.98.59.236:10000/csmar_analyze/img/icon-man.png"></el-avatar> -->
        &nbsp; &nbsp;
        <template v-if="userInfo && userInfo.id">
          <el-divider direction="vertical"></el-divider>
          &nbsp;
          <span style="    width: 10px;
    height: 12px;
    top: 5px;
    position: relative;">
            <el-dropdown @command="command">
              <span class="el-dropdown-link">
                <el-avatar :size="20"
                           :src="(userInfo && userInfo.avatar) || 'static/img/icon-man.png'"></el-avatar>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="user">{{userInfo.name}}</el-dropdown-item>
                <el-dropdown-item command="exit">
                  <img src="../assets/imgs/icon-logout.png"
                       style="position:relative;top:2px" />&nbsp;&nbsp;退出
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
        </template>
      </el-col>

    </el-row>

    <!--支付弹出框-->
    <el-dialog class="payContainer"
               :visible.sync="payDialogVisible"
               width="820px"
               center>
      <pay v-if="payDialogVisible"
           :reportId="null" />
    </el-dialog>

  </div>
</template>

<script>
import axios from 'axios'
import pay from '../components/pay'
export default {
  name: 'HelloWorld',
  data () {
    return {
      priceDialogVisible: false,
      modifyPwdDialogVisible: false,
      pwdForm: {
        oldPwd: '',
        newPwd: '',
        repeatPwd: ''
      },

      pricePackage: {},
      payDialogVisible: false,
      qrCodeUrl: '',
      willPay: 0,
      orderTimer: null,
      userInfo: {}
    }
  },
  computed: {
    refreshUserInfo: function () {
      return this.$store.state.refreshUserInfo
    }
  },
  components: {
    pay
  },
  mounted: function () {
    let temp = localStorage.getItem('userinfo')
    if (temp) {
      this.userInfo = JSON.parse(temp)
    }
  },
  watch: {
    pricePackage () {
      let _this = this
      axios.get('/api/web/order/preOrder/' + this.pricePackage).then(resp => {
        _this.willPay = resp.data
      })
    },
    refreshUserInfo () {
      let temp = localStorage.getItem('userinfo')
      if (temp) {
        this.userInfo = JSON.parse(temp)
      }
    }
  },
  methods: {
    openPayDialog () {
      // eslint-disable-next-line no-undef
      _hmt.push(['_trackEvent', '打开页面', '套餐页面'])
      this.payDialogVisible = true
    },
    command (v) {
      if (v === 'exit') {
        let _this = this
        axios.get('/api/web/auth/logout').then(resp => {
          _this.$message({
            message: '退出成功',
            type: 'success'
          })
          setTimeout(() => {
            _this.$store.commit('toFreshUserPrice')
            _this.userInfo = {}
            _this.$router.push({ 'path': '/' })
          }, 500)
        })
      }
    },
    openCustService () {
      window.open('https://care60.live800.com/live800/chatClient/chatbox.jsp?companyID=80001804&configID=968&policyId=145&enterurl=csmar&chatfrom=csmar&laiyuan=csmar', '_blank', 'width=900,height=600,top=100px,left=0px')
    }
  }
}
</script>
<style >
.priceListContainer .el-radio__input {
  display: none !important;
}

.priceListContainer .el-radio,
.el-radio__label {
  height: auto !important;
  padding: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/nav.vue